export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const ADD_DETAIL = "ADD_DETAIL";
export const DELETE_DETAIL = "DELETE_DETAIL";
export const EDIT_DETAIL = "EDIT_DETAIL";
export const GET_DETAIL = "GET_DETAIL";